export default "__VITE_ASSET__OF1gzGaS__"